module.exports = __webpack_public_path__ + "img/jiance.52db86ce.png";